<nav class="toolbar-nav px-2 d-flex align-items-center justify-content-between gap-2">
  <div class="d-flex align-items-center gap-4 ps-2">
    <button nbTooltip="Save" [disabled]="isSaving" class="toolbar-btn" (click)="saveBadge()">
      <svg class="text-secondary" width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.99913 2.4985V0.000141713H5.99813V3.00122H8.50083H8.50021C8.77644 2.99938 8.99913 2.77473 8.99913 2.4985Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.49983 9.44756e-05V2.49845C3.49983 2.77468 3.72254 2.99924 3.99877 3.00108H5.00032V0L3.49983 9.44756e-05Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.99913 9.49777H5.00026C4.60284 9.49531 4.22141 9.6528 3.94149 9.93579C3.66096 10.2163 3.50347 10.5972 3.50409 10.994V13.9999H10.4996V10.9989C10.4996 10.1695 9.82781 9.49777 8.99913 9.49777Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7061 3.20723L10.7925 0.293556C10.6049 0.105302 10.3495 9.44857e-05 10.0838 9.44857e-05H10.0007V2.49845C9.99827 3.32592 9.32832 3.9965 8.50026 3.99896H3.99882C3.17076 3.9965 2.50081 3.32592 2.49835 2.49845V9.44857e-05H1.00218C0.735797 -0.00113603 0.480487 0.104067 0.292237 0.292328C0.103987 0.480583 -0.0012178 0.735899 1.06383e-05 1.00229V12.9978C1.06383e-05 13.5515 0.4485 14 1.00218 14H2.49835V10.9989C2.49958 10.3357 2.7635 9.70018 3.23291 9.23196C3.7017 8.76377 4.33781 8.50047 5.00044 8.50047H8.99932C9.66188 8.50047 10.298 8.76379 10.7668 9.23196C11.2363 9.70015 11.5002 10.3357 11.5014 10.9989V14H12.9976C13.264 14.0012 13.5193 13.896 13.7075 13.7078C13.8958 13.5195 14.001 13.2642 13.9997 12.9978V3.93754C14.0059 3.66438 13.9001 3.40044 13.7063 3.20728L13.7061 3.20723Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <span class="toolbar-divider"></span>
    <div class="d-flex align-items-center gap-2">
      <button nbTooltip="Push up" class="toolbar-btn" (click)="pushUp()" (mousedown)="pushUpContinuously()" (mouseup)="stopPushing()">
        <svg class="text-secondary" width="12" height="8" viewBox="0 0 12 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.84756 0.751318C6.37901 0.282764 5.61807 0.282764 5.14952 0.751318L0.35152 5.54932C0.0066639 5.89417 -0.0945439 6.40771 0.0928779 6.85752C0.2803 7.30733 0.715118 7.59971 1.20242 7.59971H10.7984C11.282 7.59971 11.7205 7.30733 11.908 6.85752C12.0954 6.40771 11.9904 5.89417 11.6493 5.54932L6.85131 0.751318H6.84756Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <span
        class="push-space d-flex justify-content-center align-items-center fw-bold border rounded-pill"
        [ngClass]="{
          'push-space-error': !canBePushed,
          'push-space-normal': canBePushed
        }"
      >
        {{ pushedSpace }}
      </span>
      <button class="toolbar-btn" (click)="pushDown()" (mousedown)="pushDownContinuously()" (mouseup)="stopPushing()" nbTooltip="Push down">
        <svg class="text-secondary" width="12" height="8" viewBox="0 0 12 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.15244 7.2483C5.62099 7.71685 6.38193 7.71685 6.85048 7.2483L11.6485 2.4503C11.9933 2.10544 12.0945 1.59191 11.9071 1.14209C11.7197 0.692281 11.2849 0.399902 10.7976 0.399902L1.20159 0.403651C0.718038 0.403651 0.279471 0.696029 0.0920492 1.14584C-0.0953726 1.59565 0.00958361 2.10919 0.350691 2.45405L5.14869 7.25205L5.15244 7.2483Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
    <span class="toolbar-divider"></span>
    <div class="d-flex align-items-center gap-2">
      <button
        nbTooltip="Narrower"
        class="toolbar-btn"
        (click)="narrowContent()"
        (mousedown)="narrowContentContinuously()"
        (mouseup)="stopPushing()"
      >
        <svg class="text-secondary" width="8" height="12" viewBox="0 0 8 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.751318 5.15244C0.282764 5.62099 0.282764 6.38193 0.751318 6.85048L5.54932 11.6485C5.89417 11.9933 6.40771 12.0945 6.85752 11.9071C7.30733 11.7197 7.59971 11.2849 7.59971 10.7976V1.20159C7.59971 0.718038 7.30733 0.279471 6.85752 0.0920492C6.40771 -0.0953726 5.89417 0.00958361 5.54932 0.350691L0.751318 5.14869V5.15244Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <span
        class="push-space d-flex justify-content-center align-items-center fw-bold border rounded-pill"
        [ngClass]="{
          'push-space-error': !canContentWidthChange,
          'push-space-normal': canContentWidthChange
        }"
      >
        {{ contentWidthMM }}mm
      </span>
      <button
        nbTooltip="Wider"
        class="toolbar-btn"
        (click)="widenContent()"
        (mousedown)="widenContentContinuously()"
        (mouseup)="stopPushing()"
      >
        <svg class="text-secondary" width="8" height="12" viewBox="0 0 8 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.2483 6.84756C7.71685 6.37901 7.71685 5.61807 7.2483 5.14952L2.4503 0.35152C2.10544 0.0066639 1.59191 -0.0945439 1.14209 0.0928779C0.692281 0.2803 0.399902 0.715118 0.399902 1.20242L0.403651 10.7984C0.403651 11.282 0.696029 11.7205 1.14584 11.908C1.59565 12.0954 2.10919 11.9904 2.45405 11.6493L7.25205 6.85131L7.2483 6.84756Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
    <span class="toolbar-divider"></span>
    <button nbTooltip="Change Template" class="toolbar-btn" (click)="changeTemplate()">
      <svg class="text-secondary" width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.05025 2.05025C1.07129 3.02922 0.404602 4.2765 0.134506 5.63437C-0.13559 6.99224 0.00303356 8.3997 0.532848 9.67879C1.06266 10.9579 1.95987 12.0511 3.11101 12.8203C4.26216 13.5895 5.61554 14 7.00001 14C8.38448 14 9.73785 13.5895 10.889 12.8203C12.0401 12.0511 12.9373 10.9579 13.4672 9.67878C13.997 8.39969 14.1356 6.99223 13.8655 5.63436C13.5954 4.27649 12.9287 3.02921 11.9497 2.05025C10.637 0.737493 8.85651 -1.75034e-06 6.99999 0C5.14348 1.75035e-06 3.36301 0.737501 2.05025 2.05025ZM10.9965 6.7335C10.3175 6.05451 9.39658 5.67306 8.43634 5.67306C7.4761 5.67306 6.55518 6.05452 5.87618 6.73351L7.4167 8.27402L2.93388 8.27403V3.79118L4.47436 5.33169C5.08777 4.71821 5.86947 4.30062 6.72043 4.13181C7.57139 3.963 8.4533 4.05057 9.25445 4.38343C10.0556 4.71629 10.7399 5.27947 11.2207 6.0016C11.7015 6.72373 11.9571 7.57232 11.9552 8.43986C11.7992 7.79352 11.4674 7.20295 10.9965 6.7335Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
  <!-- <div class="d-flex align-items-center justify-content-end gap-8 h-100">
    <div class="sides d-flex bg-secondary h-100 rounded-top overflow-hidden">
      <button (click)="chooseSide()" class="is-active">
        Front side
      </button>
    </div>
  </div> -->
</nav>
